import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import PaidIcon from "@mui/icons-material/Paid";
import React from "react";
import formatCurrency from "../unit/formatCurrency";
import { Close } from "@mui/icons-material";
const PaidOffTenDaysList = ({ ...props }) => {
  const [open, setOpen] = React.useState(false);
  //   const data = props.data || [];
  const data = Object.entries(props.data).map(([date, amount]) => ({
    date: date,
    value: amount,
  }));
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <Tooltip title="10-Day Payoff Amount" placement="left">
        <PaidIcon
          sx={{
            float: "right",
            fontSize: 22,
            mt: -4,
            mb: 5,
            ml: -200,
            cursor: "pointer",
            color: "#1976d2",
            "&:hover": { color: "#0b4f94ff" },
          }}
          onClick={() => setOpen(true)}
        />
      </Tooltip>
      <Dialog
        id="dialog-loan-skip-next-payment"
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="md"
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          Amount To Pay Off
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Typography variant="body2" gutterBottom>
            Interest Per Diem: {formatCurrency(props.interestPerDiem)}
          </Typography>
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell align="center">Date</TableCell>
                  <TableCell align="center">Pay Off </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell align="center">{row.date}</TableCell>
                    <TableCell align="center">
                      {formatCurrency(row?.value)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default PaidOffTenDaysList;
